export default {"src":"https://s.sylndr.com/c-8f80a1a/_next/static/media/orangeMoney.b4c118ec.svg","height":15,"width":12,"blurWidth":0,"blurHeight":0};